/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestVkSessionUserDataFromJSON, FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestVkSessionUserDataToJSON, } from './FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestVkSessionUserData';
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest(value) {
    if (!('VkSessionUser' in value) || value['VkSessionUser'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'] == null ? undefined : json['Game'],
        'VkSessionUser': FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestVkSessionUserDataFromJSON(json['VkSessionUser']),
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
        'VkSessionUser': FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestVkSessionUserDataToJSON(value['VkSessionUser']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest.js.map